import React from 'react';
import { ClockIcon } from 'lucide-react';
import { useOfferClock } from '../hooks/useOfferClock';
export function OfferCountdown() {
  const {
    hours,
    minutes,
    seconds
  } = useOfferClock();
  const units = [{
    value: hours,
    label: 'Hours'
  }, {
    value: minutes,
    label: 'Minutes'
  }, {
    value: seconds,
    label: 'Seconds'
  }];
  return <div className="w-full rounded-2xl bg-navy-950 px-4 py-4 text-white" role="timer" aria-live="off" data-id="element-72" data-mp="28xm4o54kyjmr">
      <p className="flex items-center justify-center gap-2 text-sm font-semibold text-white/85" data-id="element-73" data-mp="1ca7swl9vfav2">
        <ClockIcon className="h-4 w-4 text-gold" aria-hidden="true" data-id="element-74" data-mp="1h9bzr59bowi8" />
        The promotional price ends in:
      </p>
      <div className="mt-3 flex items-start justify-center gap-2 sm:gap-3" data-id="element-75" data-mp="1q7wdds010fzl">
        {units.map((unit, index) => <React.Fragment key={unit.label} data-id="element-76" data-mp="2wo8bxu6rfzvp" data-mpi={index}>
            <div className="flex flex-col items-center" data-id="element-77" data-mp="2wnggqkh2s45y">
              <span className="min-w-[64px] rounded-xl bg-pulse px-2 py-2 text-center font-display text-3xl font-black tabular-nums sm:min-w-[76px] sm:text-4xl" data-id="element-78" data-mp="31mjnqagm8kgk">
                {unit.value}
              </span>
              <span className="mt-1.5 text-[11px] font-semibold uppercase tracking-wider text-white/60" data-id="element-79" data-mp="21qgmt8vhdptz">
                {unit.label}
              </span>
            </div>
            {index < units.length - 1 && <span className="pt-2 font-display text-3xl font-black text-gold sm:text-4xl" aria-hidden="true" data-id="element-80" data-mp="1rrr3rcrulzc5">
                :
              </span>}
          </React.Fragment>)}
      </div>
    </div>;
}